import createReduxForm from './createReduxForm';
import plain from './structure/plain';
export default createReduxForm(plain);


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/redux-form/es/reduxForm.js
// module id = OQV+
// module chunks = 1